export const NodeSummaryService = Symbol.for('NodeSummaryService');
